module.exports = __webpack_public_path__ + "static/media/ui-kit.c681fc6b.webp";